
export default {
    namespaced: true,
    state: {
        levels: [],  // 用来存储 LevelA-LevelE 的选择路径
        currentLevel: {
            name: '',    // 确保关键字段初始化
            id: null,
            // 其他必要字段...
        },

    },
    mutations: {
        SET_LEVELS(state, levels) {
            state.levels = levels;
        },
        CLEAR_LEVELS(state) {
            state.levels = [];
        },
        SET_LEVEL_C(state, payload) {
            state.currentLevel = {
                name: '',
                ...payload  // 安全合并传入数据
            }
        }
    },
    actions: {
        setLevels({ commit }, levels) {
            commit('SET_LEVELS', levels);
        },
        clearLevels({ commit }) {
            commit('CLEAR_LEVELS');
        }
    },
    getters: {
        getLevels(state) {
            return state.levels;
        },
        getLevelC: (state) => state.currentLevel?.name || ''
    }
};
